module.exports = __webpack_public_path__ + "static/assets/25e767fd170b7ee44d67085231953be2.svg";